import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/prev';
import { mergeStyles } from '@cian/utils';
import { useFieldHasErrors } from '../utils';
import { useFormikContext, Field } from 'formik';
import { IFormValues } from '../../DealRentModal';
import { Label } from './Label';
import * as styles from '../../index.css';

export interface IIsTermAccepted {
  freeDealRent: boolean;
}

export const IsTermAccepted = ({ freeDealRent }: IIsTermAccepted) => {
  const invalid = useFieldHasErrors('termAccepted');
  const { values } = useFormikContext<IFormValues>();

  return (
    <div {...mergeStyles(styles['field'], styles['span-columns'])}>
      <Field
        name="termAccepted"
        as={Checkbox}
        checked={values.termAccepted}
        custom={{
          invalid,
          label: <Label freeDealRent={freeDealRent} invalid={invalid} />,
        }}
      />
    </div>
  );
};
